import React, { FC } from 'react';
import { Text } from 'react-native';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { connect } from 'react-redux';
import { getNCFileByPartId } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { getPartByID } from '@reducers/parts';

interface ToolsDetailsJobsProps {}

const ToolsDetailsJobsComponent: FC<ToolsDetailsJobsProps> = ({
  clearTools,
  getNCFileByPartId,
  getTools,
  updateHeaderConfig,
  getProductionBatchByPart,
  getPartByID,
  operationsSearch
}) => {
  const title = useTitle();

  usePartDetails({
    clearTools,
    getNCFileByPartId,
    getTools,
    updateHeaderConfig,
    getProductionBatchByPart,
    getPartByID,
    operationsSearch
  });

  return (
    <DetailsPageWrapper title={title.job}>
      <Text>PartDetailsJobs</Text>
    </DetailsPageWrapper>
  );
};

const ToolsDetailsJobs = connect(({}) => ({}), {
  clearTools,
  getNCFileByPartId,
  getTools,
  updateHeaderConfig,
  getProductionBatchByPart,
  getPartByID,
  operationsSearch
})(ToolsDetailsJobsComponent);

export { ToolsDetailsJobs };
